import React from 'react';
import './modernDatePicker.scss';

interface ModernDatePickerProps {
  label?: string;
  value: Date | null;
  onChange: (date: Date | null) => void;
  placeholder?: string;
  error?: string;
  fullWidth?: boolean;
  className?: string;
  disabled?: boolean;
}

const ModernDatePicker = ({
  label,
  value,
  onChange,
  placeholder = 'Select date',
  error,
  fullWidth = true,
  className = '',
  disabled = false,
}: ModernDatePickerProps) => {
  // Use local date formatting instead of toISOString().
  const formattedValue: string = value
    ? `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`
    : '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value) {
      // Create date in local time.
      const [year, month, day] = e.target.value.split('-').map(Number);
      onChange(new Date(year, month - 1, day)); // month is 0-indexed
    } else {
      onChange(null);
    }
  };

  return (
    <div
      className={`modern-date-picker-container ${fullWidth ? 'full-width' : ''} ${className}`}
    >
      {label && <label className="modern-date-picker-label">{label}</label>}
      <div className="modern-date-picker-field-wrapper">
        <div className="modern-date-picker-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
        </div>
        <input
          type="date"
          className={`modern-date-picker-field ${error ? 'error' : ''}`}
          value={formattedValue}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
        />
      </div>
      {error && <div className="modern-date-picker-error">{error}</div>}
    </div>
  );
};

export default ModernDatePicker;
